module.exports = __webpack_public_path__ + "static/media/stream_bkpilates_video_classes.7e82db15.svg";